import EditPersonalInfo from './EditPersonalInfo'
export default EditPersonalInfo